import axiosService from 'services/axios.service';

const API_URL = process.env.REACT_APP_URL_API;

const BASE_API_URL = `${API_URL}/v1/admin`;

export const getTokenValue = async (): Promise<any> => {
    const response = await axiosService.get(`${BASE_API_URL}/token-value`);
    return response?.data?.data?.data;
};

export const APIhandleAfterPayout = async (payload: any): Promise<any> => {
    const response = await axiosService.post(`${BASE_API_URL}/accounting/mark/payouts`, payload);

    return response?.data?.data;
};

export const APIhandleAfterAllPayout = async (payload: any): Promise<any> => {
    const response = await axiosService.post(`${BASE_API_URL}/accounting/all/mark/payouts`, payload);

    return response?.data?.data;
};
